import React, { useState } from "react"
import styled, { css } from "styled-components"
import { AppFunctionComponent } from "../../../types"
import Input from "./input.component"
import { Results, ResultsProps } from "./results.component"
import useReducedItems from "./use-reduced-items.hook"

const ResultsContainer = styled(Results)<{ $active: boolean }>`
  transition: opacity 0.3s ease-in-out, visibility 0.5s ease-in-out;
  visibility: hidden;
  opacity: 0;
  ${({ $active }) =>
    $active &&
    css`
      opacity: 1;
      visibility: visible;
    `};
`

const Container = styled.div`
  position: relative;

  ${ResultsContainer} {
    position: absolute;
    width: 100%;
    bottom: -10px;
    transform: translateY(100%);
  }
`

export interface Props extends ResultsProps {
  defaultValue?: string
  placeholder: string
  label: string
}

const InputSearch: AppFunctionComponent<Props> = ({
  className,
  defaultValue = "",
  items,
  newItemNotifyText,
  onNewItemNotifyMouseDown,
  onItemMouseDown,
  ...props
}) => {
  const [focused, setFocused] = useState(false)
  const [value, setValue] = useState(defaultValue)
  const reducedItems = useReducedItems({ items, value })

  const updateValue = (v: string) => setValue(v)

  const focus = () => setFocused(true)

  const setInitState = () => {
    setFocused(false)
    setValue("")
  }

  return (
    <Container className={className}>
      <Input
        onBlur={setInitState}
        onFocus={focus}
        onValueChange={updateValue}
        defaultValue={value}
        {...props}
      />
      <ResultsContainer
        $active={Boolean(value) && focused}
        items={reducedItems}
        newItemNotifyText={newItemNotifyText}
        onNewItemNotifyMouseDown={onNewItemNotifyMouseDown}
        onItemMouseDown={onItemMouseDown}
      />
    </Container>
  )
}

export default InputSearch
